<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <DoctorQueueTable
      permission-key="other_patients"
      endpoint="/maternitypatients"
      action-path="/maternitytreatment"
      action-label="Treatment"
      no-permission-text="You have no permission to View Maternity Patients"
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DoctorQueueTable from "@/components/DoctorQueueTable.vue";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Maternity Patients",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, DoctorQueueTable },
  data() {
    return {
      title: "Maternity Patients",
      items: [{ text: "Dashboard", to: "/" }, { text: "Maternity Patients", active: true }],
    };
  },
};
</script>
